<template>
  <div class="myStation">
    <NavBar v-if="sourceIsH5" :narBarTitle="$t('我的工位')" />
    <div class="selectionBar">
      <van-search
        v-model="searchValue"
        :placeholder="$t('搜索')"
        class="search"
        @input="onInput"
      />
      <div class="calendar" @click="dateShow = true">
        <img src="@/assets/images/calendar.png" alt="" />
      </div>
      <van-popup
        v-model="dateShow"
        position="bottom"
        :style="{ height: '630px' }"
      >
        <div class="dateModalList">
          <div
            v-for="item in allTime"
            :key="item.key"
            :style="{
              backgroundColor: item.backgroundColor,
              color: item.color,
            }"
            class="dateModalListOne"
            @click="choseTime(item)"
          >
            <div class="dateModalListText">
              {{ item.value }}
            </div>
          </div>
        </div>
        <van-calendar
          @confirm="onConfirm"
          color="#1989fa"
          :min-date="minDate"
          :poppable="false"
          :style="{ height: '580px' }"
          :default-date="selectedTime"
        />
      </van-popup>
    </div>

    <van-tabs color="#009BFF" @click="onTabClick">
      <van-tab :title="$t('未结束')" name="start">
        <van-pull-refresh
          v-model="isLoading"
          @refresh="onRefresh"
          :style="{ height: height - 20 + 'px', overflow: 'auto' }"
        >
          <van-list
            v-model="loading"
            :finished="finished"
            @load="onLoad"
            :immediate-check="false"
            :finished-text="$t('没有更多了')"
            offset="15"
          >
            <div class="loading-style" v-if="isInfoLoading">
              <van-loading type="spinner" vertical>{{
                $t('加载中...')
              }}</van-loading>
            </div>
            <div class="content" v-else>
              <div
                class="card_info"
                v-for="item in data && data.length > 0 && data"
                :key="item.id"
                @click="gotoMeeting(item)"
              >
                <div class="card_title">
                  <div>{{ item.stationName }}</div>
                  <van-tag
                    v-if="item.signState == 'SING_IN'"
                    class="card_tag_signIn"
                    type="primary"
                    >{{ $t('已签到') }}</van-tag
                  >
                </div>
                <p v-if="item.mixMakeDay !== 'DAY'">
                  {{ $t('时间：') }}{{ getYear(item.startTime) }}
                  {{ getTime(item.mixMakeDay, item.startTime) }}-{{
                    getTime(item.mixMakeDay, item.endTime)
                  }}
                </p>
                <p v-else>{{ $t('时间：') }}{{ getYear(item.startTime) }}</p>
                <div
                  class="card_button_box"
                  v-if="item.signState === 'SING_IN'"
                >
                  <div
                    class="card_button_reserve"
                    v-if="item.statusAttribute === 'IN_USE'"
                    @click.stop="endEarly(item)"
                  >
                    {{ $t('提前结束') }}
                  </div>
                </div>
                <div
                  class="card_button_box"
                  v-if="item.signState === 'NOT_SING_IN'"
                >
                  <div
                    class="card_button_reserve"
                    v-if="
                      dayjs().isBefore(dayjs(item.startTime)) ||
                      (item.isSign && canYouSignIn(item) === 'SIGNIN')
                    "
                    @click.stop="onStartCancel(item)"
                  >
                    {{ $t('取消预约') }}
                  </div>
                  <div
                    class="card_button_reserve"
                    v-if="
                      (!item.isSign &&
                        !dayjs().isBefore(dayjs(item.startTime))) ||
                      (item.isSign &&
                        !dayjs().isBefore(dayjs(item.startTime)) &&
                        canYouSignIn(item) !== 'SIGNIN')
                    "
                    @click.stop="endEarly(item)"
                  >
                    {{ $t('提前结束') }}
                  </div>
                  <div
                    class="card_button_signIn"
                    v-if="
                      item.isSign &&
                      item.isH5Sign &&
                      canYouSignIn(item) === 'SIGNIN'
                    "
                    @click.stop="onOK(item)"
                  >
                    {{ $t('签到') }}
                  </div>
                </div>
              </div>
              <div class="no-uesdMeetingRoom" v-if="data && !data.length > 0">
                <img src="@/assets/images/empty.png" alt="" />
                <div>{{ $t('暂无信息') }}</div>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
      </van-tab>
      <van-tab :title="$t('已结束')" name="end">
        <van-pull-refresh
          v-model="isLoading"
          @refresh="onRefresh"
          :style="{ height: height - 20 + 'px', overflow: 'auto' }"
        >
          <van-list
            v-model="loading"
            :finished="finished"
            @load="onLoad"
            :immediate-check="false"
            :finished-text="$t('没有更多了')"
            offset="12"
          >
            <div class="loading-style" v-if="isInfoLoading">
              <van-loading type="spinner" vertical>{{
                $t('加载中...')
              }}</van-loading>
            </div>
            <div class="content" v-else>
              <div
                class="card_info"
                v-for="item in data"
                :key="item.id"
                @click="gotoMeeting(item)"
              >
                <div class="card_title">
                  <div>{{ item.stationName }}</div>
                  <van-tag
                    v-if="item.signState == 'SING_IN'"
                    class="card_tag_signIn"
                    type="primary"
                    >{{ $t('已签到') }}</van-tag
                  >
                  <van-tag v-else class="card_tag_notSignIn" type="primary">{{
                    $t('未签到')
                  }}</van-tag>
                </div>
                <p v-if="item.mixMakeDay !== 'DAY'">
                  {{ $t('时间：') }}{{ getYear(item.startTime) }}
                  {{ getTime(item.mixMakeDay, item.startTime) }}-{{
                    getTime(item.mixMakeDay, item.endTime)
                  }}
                </p>
                <p v-else>{{ $t('时间：') }}{{ getYear(item.startTime) }}</p>
                <div
                  class="card_button"
                  @click.stop="toStationReservation(item)"
                >
                  {{ $t('再次预约') }}
                </div>
              </div>
              <div
                class="no-uesdMeetingRoom"
                v-if="!data.length > 0 && !data.length > 0"
              >
                <img src="@/assets/images/empty.png" alt="" />
                <div>{{ $t('暂无信息') }}</div>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
import NavBar from '@/components/navBar'
import {
  queryAppointment,
  updateAppointmentStatus,
  earlyTermination,
} from '@/services/api'
import Vue from 'vue'
import { ref } from 'vue'
import {
  Search,
  Tab,
  Tabs,
  Tag,
  List,
  Calendar,
  PullRefresh,
  Loading,
  Popup,
} from 'vant'
import moment from 'moment'
import { Toast } from 'vant'
import dayjs from 'dayjs'

Vue.use(Search)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Tag)
Vue.use(List)
Vue.use(Calendar)
Vue.use(PullRefresh)
Vue.use(Loading)
Vue.use(Popup)

export default {
  name: 'myStation',
  components: {
    NavBar,
  },
  data() {
    return {
      allTime: [
        {
          key: 1,
          value: this.$t('全部时间'),
          color: '#666666',
          backgroundColor: '#F4F4F4',
        },
        {
          key: 2,
          value: this.$t('一周内'),
          color: '#ffffff',
          backgroundColor: '#009BFF',
        },
      ],

      minDate: new Date(),
      sourceIsH5: true,
      dateShow: false,
      searchValue: '',
      isLoading: false,
      isInfoLoading: false,
      height: '',
      user: {},
      finished: false,
      loading: false,
      companyId: '',
      startTime: '',
      endTime: '',
      data: [],
      page: '',
      pageSize: '',
      state: 'start',
      searchValue: '',
      selectedTime: '',
      selectTime: {
        key: 2,
        value: this.$t('一周内'),
        color: '#ffffff',
        backgroundColor: '#009BFF',
      },
    }
  },
  methods: {
    onRefresh() {
      this.data = []
      this.finished = false
      this.loading = true
      this.isLoading = false
      this.isInfoLoading = true
      this.page = 1
      queryAppointment({
        companyId: this.companyId,
        endTime: this.endTime,
        startTime: this.startTime,
        userId: this.user.id,
        fuzzyValue: this.searchValue,
        page: this.page,
        state: this.state,
        pageSize: this.pageSize,
      }).then((res) => {
        if (res.code === 200) {
          this.data = res.data.results
          this.isInfoLoading = false
          this.loading = false
          this.finished = false
          Toast(this.$t('刷新成功'))
        }
      })
    },
    async onOK(value) {
      const data = await updateAppointmentStatus({
        stationSignId: value.id,
        state: 'YES',
        userId: this.user.id,
      })
      if (data.code === 200) {
        this.getData()
        Toast(this.$t('签到成功'))
      } else {
        Toast(this.$t('此时间段不可签到！'))
      }
    },
    gotoMeeting(data) {
      this.$router.push({
        name: 'StationInfo',
        query: {
          stationId: data.id,
          makeState: data.makeState,
        },
      })
    },
    async onLoad() {
      if (this.data.length <= 5) {
        this.finished = true
        this.loading = false
        return
      }
      this.page++
      const list = await queryAppointment({
        companyId: this.companyId,
        userId: this.user.id,
        endTime: this.endTime,
        startTime: this.startTime,
        page: this.page,
        fuzzyValue: this.searchValue,
        state: this.state,
        pageSize: this.pageSize,
      })
      this.loading = false
      if (list.code == 200) {
        if (list.data.results.length == 0) {
          this.finished = true
        } else {
          this.data = this.data.concat(list.data.results)
          if (this.data.length >= list.data.count) {
            this.finished = true
          }
        }
      } else {
        this.data = []
        this.loading = false
      }
    },

    onConfirm(value) {
      this.selectedTime = value
      this.dateShow = false
      if (this.state === 'start' || this.state === 'oldStart') {
        if (this.selectTime.key == 2) {
          this.endTime =
            moment(value).add(6, 'days').format('YYYY-MM-DD') + ' 23:59:59'
          this.startTime = moment(value)
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss')
        }
        if (this.selectTime.key == 1) {
          this.endTime = null
          this.startTime = null
        }
      } else {
        if (this.selectTime.key == 2) {
          this.endTime = moment(value)
            .endOf('day')
            .format('YYYY-MM-DD HH:mm:ss')
          this.startTime =
            moment(value).subtract(6, 'days').format('YYYY-MM-DD') + ' 00:00:00'
        }
        if (this.selectTime.key == 1) {
          this.endTime = null
          this.startTime = null
        }
      }
      if (this.getTimeDate(value) !== this.$t('今天')) {
        if (this.state === 'start') {
          this.state = 'oldStart'
          this.getData()
          this.dateShow = false
          return
        }
        if (this.state === 'end') {
          this.state = 'oldEnd'
          this.getData()
          this.dateShow = false
          return
        }
        this.getData()
        this.dateShow = false
      } else {
        if (this.state === 'oldStart') {
          this.state = 'start'
          this.getData()
          this.dateShow = false
          return
        }
        if (this.state === 'oldEnd') {
          this.state = 'end'
          this.getData()
          this.dateShow = false
          return
        }
        this.getData()
        this.dateShow = false
      }
    },
    choseTime(data) {
      this.allTime.map((item) => {
        if (item.key == data.key) {
          item.color = '#ffffff'
          item.backgroundColor = '#009BFF'
          this.selectTime = { key: item.key, value: item.value }
        } else {
          item.color = '#666666'
          item.backgroundColor = '#F4F4F4'
        }
      })
    },
    getData() {
      this.loading = true
      this.isInfoLoading = true
      this.page = 1
      queryAppointment({
        companyId: this.companyId,
        endTime: this.endTime,
        startTime: this.startTime,
        userId: this.user.id,
        fuzzyValue: this.searchValue,
        page: this.page,
        state: this.state,
        pageSize: this.pageSize,
      }).then((res) => {
        this.data = res.data.results
        this.isInfoLoading = false
        this.loading = false
        this.finished = false
      })
    },

    async endEarly(value) {
      const res = await earlyTermination({
        companyId: this.companyId,
        userId: this.user.id,
        stationSignId: value.id,
      })
      if (res.code === 200) {
        this.getData()
        Toast(`${res.msg}`)
      } else {
        Toast(`${res.msg}`)
      }
    },
    //判断当前时间是否处于两个时段内
    judgmentTime(startTime, endTime) {
      const startDate = new Date(startTime)
      const endDate = new Date(endTime)
      const currentDate = new Date()
      if (startDate <= currentDate && currentDate < endDate) {
        return true
      }
    },

    init() {
      ;(this.companyId = this.user.companyId - 0),
        (this.endTime =
          moment().add(6, 'days').format('YYYY-MM-DD') + ' 23:59:59'),
        (this.startTime = moment()
          .startOf('day')
          .format('YYYY-MM-DD HH:mm:ss')),
        (this.pageSize = 10),
        (this.loading = true)
      this.isInfoLoading = true
      this.page = 1
      queryAppointment({
        companyId: this.companyId,
        endTime: this.endTime,
        startTime: this.startTime,
        userId: this.user.id,
        fuzzyValue: this.searchValue,
        page: this.page,
        state: this.state,
        pageSize: this.pageSize,
      }).then((res) => {
        if (res.code === 200) {
          this.data = res.data.results
          this.isInfoLoading = false
          this.finished = false
          this.loading = false
        }
      })
    },
    async onStartCancel(value) {
      const data = await updateAppointmentStatus({
        stationSignId: value.id,
        state: 'NO',
        userId: this.user.id,
      })
      if (data.code === 200) {
        this.getData()
        Toast(this.$t('取消成功！'))
      } else {
        Toast(this.$t('此时间段不可取消预约！'))
      }
    },

    //处理预约签到逻辑
    canYouSignIn(value) {
      //当预约时间段是天
      const createdTimeToDay = moment().isSame(moment(value.createdTime), 'day') //创建时间是否为今天
      const startTimeToDay = moment().isSame(moment(value.startTime), 'day') //预约时间是否为今天
      // if (value.mixMakeDay == 'DAY') {
      //   const isMorning = dayjs().hour() < 12 //当前时间是否为上午
      //   const createdTimeIsMorning = dayjs(value.createdTime).hour() < 12 //创建时间是否为上午
      //   const signDate =
      //     dayjs() <
      //     dayjs(value.createdTime).hour(dayjs(value.createdTime).hour() + 2) //当天下午预约，可签到时间为创建时间后两小时之内，当前时间是否处于可签到时间范围
      //   //非当天预约的情况下，签到截止的时间为12点
      //   if (!createdTimeToDay && startTimeToDay && isMorning) {
      //     return 'SIGNIN'
      //   }
      //   //当天上午预约。签到截止时间为12点
      //   if (
      //     createdTimeToDay &&
      //     startTimeToDay &&
      //     createdTimeIsMorning &&
      //     isMorning
      //   ) {
      //     return 'SIGNIN'
      //   }
      //   //当天下午预约，签到时间为创建时间后两个小时以内
      //   if (
      //     createdTimeToDay &&
      //     startTimeToDay &&
      //     !createdTimeIsMorning &&
      //     signDate
      //   ) {
      //     return 'SIGNIN'
      //   }
      //   return 'NOT_SIGNIN'
      // }

      //当预约时间段是半天
      // if (value.mixMakeDay == 'HALF_A_DAY') {
      //   const beforeNine =
      //     dayjs(value.createdTime) < dayjs().hour(9).minute(0).second(0) //创建时间是否在当天九点之前
      //   const beforeThirteen =
      //     dayjs().hour(13).minute(0).second(0) > dayjs(value.createdTime) &&
      //     dayjs(value.createdTime) > dayjs().hour(12).minute(0).second(0) //创建时间是否在当天的12点后13点前
      //   const afternine =
      //     dayjs(value.createdTime) >= dayjs().hour(9).minute(0).second(0) &&
      //     dayjs(value.endTime).hour() === 12 //当天九点之后预约的上午
      //   const afterThirteen =
      //     dayjs(value.createdTime) >= dayjs().hour(13).minute(0).second(0) &&
      //     dayjs(value.endTime).hour() === 23 //当天十三点之后预约的下午
      //   if (value.isRelease) {
      //     //当天上午九点钟之前预约，签到范围在九点加配置的分钟
      //     if (
      //       beforeNine &&
      //       startTimeToDay &&
      //       dayjs() < dayjs().hour(9).minute(value.releaseTime).second(0)
      //     ) {
      //       return 'SIGNIN'
      //     }
      //     //下午十三点前预约，签到范围在十三点点加配置的分钟
      //     if (
      //       beforeThirteen &&
      //       startTimeToDay &&
      //       dayjs() < dayjs().hour(13).minute(value.releaseTime).second(0)
      //     ) {
      //       return 'SIGNIN'
      //     }
      //     //上午九点钟之后预约上午，签到范围在创建时间加配置的分钟
      //     if (
      //       afternine &&
      //       startTimeToDay &&
      //       dayjs() <
      //         dayjs(value.createdTime)
      //           .minute(
      //             dayjs(value.createdTime).minute() + (value.releaseTime - 0)
      //           )
      //           .second(0)
      //     ) {
      //       return 'SIGNIN'
      //     }
      //     //上午九点钟之后预约上午，签到范围在创建时间加配置的分钟
      //     if (
      //       afterThirteen &&
      //       startTimeToDay &&
      //       dayjs() <
      //         dayjs(value.createdTime)
      //           .minute(
      //             dayjs(value.createdTime).minute() + (value.releaseTime - 0)
      //           )
      //           .second(0)
      //     ) {
      //       return 'SIGNIN'
      //     }
      //     return 'NOT_SIGNIN'
      //   } else {
      //     if (
      //       dayjs() >= dayjs(value.startTime) &&
      //       dayjs() < dayjs(value.endTime)
      //     ) {
      //       console.log(1)
      //       return 'SIGNIN'
      //     }
      //     return 'NOT_SIGNIN'
      //   }
      // }

      //当预约时间段为小时/半小时
      if (
        value.mixMakeDay == 'HALF_A_HOUR' ||
        value.mixMakeDay == 'HOURS' ||
        value.mixMakeDay == 'CUSTOM_TIME' ||
        value.mixMakeDay == 'DAY'
      ) {
        const beforeCreatedTime =
          dayjs(value.createdTime) < dayjs(value.startTime) //创建时间在预约时间段之前
        const afterTime = dayjs(value.createdTime) >= dayjs(value.startTime) //创建时间在预约时间段之前
        if (value.isRelease) {
          if (
            beforeCreatedTime &&
            startTimeToDay &&
            dayjs() >= dayjs(value.startTime) &&
            dayjs(value.startTime)
              .minute(
                dayjs(value.startTime).minute() + (value?.releaseTime ?? 0 - 0)
              )
              .second(0) > dayjs()
          ) {
            return 'SIGNIN'
          }
          if (
            afterTime &&
            startTimeToDay &&
            dayjs() <
              dayjs(value.createdTime)
                .minute(
                  dayjs(value.createdTime).minute() +
                    (value?.releaseTime ?? 0 - 0)
                )
                .second(0)
          ) {
            return 'SIGNIN'
          }
          return 'NOT_SIGNIN'
        } else {
          if (
            dayjs() >= dayjs(value.startTime) &&
            dayjs() < dayjs(value.endTime)
          ) {
            return 'SIGNIN'
          }
          return 'NOT_SIGNIN'
        }
      }
    },
    getYear(value) {
      return moment(value).format('YYYY-MM-DD')
    },
    onTabClick(name, title) {
      this.finished = false
      this.loading = false
      this.selectedTime = new Date()
      if (name === 'start') {
        if (this.selectTime.key == 2) {
          this.endTime =
            moment().add(6, 'days').format('YYYY-MM-DD') + ' 23:59:59'
          this.startTime = moment(new Date())
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss')
        }
        if (this.selectTime.key == 1) {
          this.endTime = null
          this.startTime = null
        }
      }
      if (name === 'end') {
        if (this.selectTime.key == 2) {
          this.endTime = moment(new Date())
            .endOf('day')
            .format('YYYY-MM-DD HH:mm:ss')
          this.startTime =
            moment().subtract(6, 'days').format('YYYY-MM-DD') + ' 00:00:00'
        }
        if (this.selectTime.key == 1) {
          this.endTime = null
          this.startTime = null
        }
      }
      if (name === 'start' || name === 'oldStart') {
        this.minDate = new Date()
      } else {
        this.minDate = new Date(2010, 0, 1)
      }
      if (this.getTimeDate(this.selectedTime) !== this.$t('今天')) {
        if (name === 'start') {
          this.state = 'oldStart'
          this.getData()
          return
        }
        if (name === 'end') {
          this.state = 'oldEnd'
          this.getData()

          return
        }
      } else {
        this.state = name
        this.getData()
      }
    },
    onInput(value) {
      this.searchValue = value
      this.getData()
    },
    getTimeDate(value) {
      return moment(value).calendar(null, {
        sameDay: this.$t('[今天]'),
        nextDay: this.$t('[明天]'),
        nextWeek: this.$t('[明天和以后]'),
        lastDay: this.$t('[昨天]'),
        lastWeek: this.$t('[上周]'),
        sameElse: this.$t('[一周以后]'),
      })
    },
    getTime(mixMakeDay, value) {
      if (mixMakeDay !== 'DAY') {
        return moment(value).format('HH:mm')
      }
      return moment(value).format('YYYY-MM-DD')
    },
    ExtensionOfTime(value, releaseTime) {
      const event = new Date(value)
      const min = event.getMinutes()
      return event.setMinutes(min + (releaseTime - 0))
    },
    //跳转至工位预约页面
    toStationReservation(value) {
      // this.$router.push({
      //   path:'/meeting/:reservationInfo',
      //   name:'Meeting',
      //   params:{
      //     // reservationInfo: value
      //     reservationInfo: {
      //        stationId: 1,
      //        stationName: "测试"
      //     }
      //   }
      // })

      this.$router.push({
        name: 'stationAppointment',
        params: {
          // startTime: `${dayjs().format('YYYY-MM-DD')} 00:00:00`,
          // endTime: `${dayjs().format('YYYY-MM-DD')} 23:59:59`,
          // workspaceId: 285,
          // workAreaId: 2,
          // stationId: 1,
          // stationName: "测试"

          startTime: `${dayjs().format('YYYY-MM-DD')} 00:00:00`,
          endTime: `${dayjs().format('YYYY-MM-DD')} 23:59:59`,
          workspaceId: value.workSpaceId,
          workAreaId: value.workAreaId,
          stationId: value.stationId,
          stationName: value.stationName,
        },
      })
    },
  },
  mounted() {
    this.height = document.body.scrollHeight - 135
    this.user = JSON.parse(localStorage.getItem('user'))
    this.selectedTime = new Date()
    this.init()
    if (window.injectData && window.injectData.source == 'NewWorkApp') {
      this.sourceIsH5 = false
    }
  },
}
</script>
<style lang="less" scoped>
.myStation {
  position: relative;
  height: 100%;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  flex: 1;

  overflow: hidden;
}
// .content {
//   flex: 1;
//   overflow: auto;
// }
.selectionBar {
  height: 40px;
  background: #ffffff;
  display: flex;
  align-items: center;
  font-size: 14px;
  width: 100%;
  .calendar {
    // width: 20%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 24px;
      height: 24px;
    }
  }
}
.loading-style {
  width: 100%;
  text-align: center;
  margin-top: 50px;
}
.no-uesdMeetingRoom {
  margin-top: 44px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: 24px;
  color: #666666;
  font-size: 14px;
  img {
    width: 96px;
    height: 61px;
    margin-bottom: 8px;
  }
}
.card_info {
  width: 355px;
  background: #fefffe;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.15);
  border-radius: 6px;
  margin: 10px auto;
  padding-top: 16px;
  overflow: auto;
  padding-bottom: 13px;
}
.card_title {
  width: 331px;
  display: flex;
  margin: 0 auto;
  justify-content: space-between;
  align-items: center;
}
.card_title div {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 24px;
}
.card_tag_signIn {
  display: block;
  width: 52px;
  height: 22px;
  background: #e6f7ff;
  border-radius: 2px;
  border: 1px solid #91d5ff;
  text-align: center;
  line-height: 22px;
  color: #1890ff;
}
.card_tag_notSignIn {
  display: block;
  height: 22px;
  background: #fafafa;
  border-radius: 2px;
  border: 1px solid #d9d9d9;
  text-align: center;
  line-height: 22px;
  color: #575757;
}
.card_info p {
  height: 16px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 16px;
  margin-left: 12px;
  margin-top: 6px;
}
.card_button {
  width: 80px;
  height: 28px;
  background: #009bff;
  border-radius: 24px;
  color: #ffffff;
  line-height: 28px;
  text-align: center;
  float: right;
  margin-right: 13px;
  margin-top: 8px;
}
.card_button_reserve {
  width: 80px;
  font-size: 13px;
  height: 28px;
  border-radius: 24px;
  border: 1px solid #009bff;
  color: #009bff;
  text-align: center;
  line-height: 28px;
}
.card_button_signIn {
  font-size: 13px;
  width: 64px;
  height: 28px;
  background: #009bff;
  border-radius: 24px;
  color: #ffffff;
  text-align: center;
  line-height: 28px;
  margin-left: 6px;
}
.card_button_box {
  height: 28px;
  display: flex;
  justify-content: space-between;
  float: right;
  margin-right: 13px;
  margin-top: 8px;
}
.search {
  width: 337px;
}
.dateModalList {
  width: 100%;
  height: 45px;
  display: flex;
  align-items: center;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
  -webkit-overflow-scrolling: touch;
  padding: 0 5px;
  padding-left: 16px;

  .dateModalListOne {
    margin-right: 8px;
    border-radius: 4px;
  }
}
.dateModalListText {
  width: 80px;
  height: 32px;
  font-size: 13px;
  line-height: 32px;
  text-align: center;
}
</style>
